import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
const Footer = () => {
  return (
    <>
      {/* <!-- Footer --> */}

      {/* <!-- Footer Start --> */}
      <footer className="footer mt-5 contact-bg text-light pt-5">
        <div className="container">
          <div className="row g-4">
            {/* Logo + About */}
            <div className="col-lg-4 col-md-6">
              <img
                className="img-fluid mb-3"
                src="/images/assets/rapidLabLogoWhite.png"
                alt="Rapid Lab Logo"
                style={{ maxWidth: "150px" }}
              />
              <h5>Rapid Lab & Diagnostics</h5>
              <p className="small">
                Your trusted partner for fast, accurate, and reliable medical
                testing services. We are committed to delivering quality
                diagnostics with care and professionalism.
              </p>
            </div>

            {/* Quick Links */}
            <div className="col-lg-4 col-md-6">
              <h5 className="mb-3">Quick Links</h5>
              <ul className="list-unstyled d-flex flex-column gap-2">
                <li>
                  <HashLink
                    className="text-light text-decoration-none footer-link under-line"
                    to="/#rapid-home"
                  >
                    Home
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    className="text-light text-decoration-none footer-link under-line"
                    to="/about-us#rapid-about-us"
                  >
                    About Us
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    className="text-light text-decoration-none footer-link under-line"
                    to="/services#rapid-services"
                  >
                    Services
                  </HashLink>
                </li>
                <li>
                  <Link
                    className="text-light text-decoration-none footer-link under-line"
                    to="/forms#appointment-form"
                  >
                    Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="col-lg-4 col-md-12">
              <h5 className="mb-3">Contact Us</h5>

              <p className="d-flex align-items-center gap-2 small">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-telephone-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                    />
                  </svg>
                </span>{" "}
                +233 55 066 2915 <br /> +233 20 592 5509
              </p>

              <p className="d-flex align-items-center gap-2 small">
                ✉️ rapidlabdiagnostics@gmail.com <br />
                info@rapidlabdiagnostics.com
              </p>

              {/* Socials */}
              <div className="mt-3">
                <h6>Connect with Us</h6>
                <div className="d-flex gap-3 mt-2">
                  <Link
                    href="https://web.facebook.com/p/Rapid-Laboratory-Diagnostics-Centre-61565006593035/"
                    className="text-light"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-facebook fs-5"></i>
                  </Link>

                  <Link
                    href="https://instagram.com/rapidlabdiagnostics"
                    className="text-light"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-instagram fs-5"></i>
                  </Link>

                  <Link
                    href="https://wa.me/message/TITUAAVTBPDCD1"
                    className="text-light"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-whatsapp fs-5"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Divider */}
          <hr className="border-light opacity-25 my-4" />

          {/* Footer Bottom */}
          <div className="text-center small pb-3">
            &copy; {new Date().getFullYear()} Rapid Lab & Diagnostics. All
            rights reserved.
          </div>
        </div>
      </footer>
      {/* <!-- Footer End --> */}
    </>
  );
};

export default Footer;
